"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureFlag = void 0;
const react_1 = __importDefault(require("react"));
const CoreFeaturesContext_1 = require("./CoreFeaturesContext");
const types_1 = require("./types");
function useFeatureFlag(flagKey) {
    const context = react_1.default.useContext(CoreFeaturesContext_1.CoreFeaturesContext);
    if (context === undefined) {
        throw new Error('useFeatureFlag must be used within a CoreFeaturesProvider');
    }
    const key = (0, types_1.isFeatureFlagWithSubjectType)(flagKey) ? flagKey.key : flagKey;
    const flagValue = context.getFeatureFlagAssignment(key);
    return {
        isLoading: context.isLoading,
        isEnabled: context.isLoading ? undefined : Boolean(flagValue),
    };
}
exports.useFeatureFlag = useFeatureFlag;
